import { Alert } from "@volca/ui/components/ui/alert";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { useResendWelcomeEmail } from "./query";

export const WelcomeEmailStatus = ({
  sent = false,
  failed = false,
}: {
  sent?: boolean;
  failed?: boolean;
}) =>
  sent || failed ? (
    <Alert color={sent ? "success" : "danger"}>
      {sent
        ? "Welcome email sent."
        : "The account exists, but the welcome email could not be sent. Send it again to complete sign-in setup."}
    </Alert>
  ) : null;

export const WelcomeEmailNotice = ({
  userId,
  failed = false,
}: {
  userId: string;
  failed?: boolean;
}) => {
  const send = useResendWelcomeEmail(userId);
  return (
    <Stack gap={2} className="w-full">
      <WelcomeEmailStatus
        sent={send.isSuccess}
        failed={failed || send.isError}
      />
      <Stack direction="row" align="center" gap={2} wrap>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          loading={send.isPending}
          loadingLabel="Sending welcome email"
          onClick={() => send.mutate()}
        >
          {(failed || send.isError) && !send.isSuccess
            ? "Retry welcome email"
            : "Send welcome email again"}
        </Button>
      </Stack>
    </Stack>
  );
};
